import { render } from "./ImportType.vue?vue&type=template&id=9070f49a"
import script from "./ImportType.vue?vue&type=script&lang=js"
export * from "./ImportType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__